// Translate the legacy callable's quota message without altering enforcement.
export function aiQuotaCopy(message) {
    const match = /^You have used all (\d+) free tutor questions\. Unlock this pack for unlimited access\.$/.exec(message || '');
    return match
        ? 'Your free Study Partner allowance has been reached. Refresh to check the latest daily allowance, or unlock this pack for additional AI support, subject to usage limits.'
        : message;
}
